import {createAsyncThunk, createSlice,} from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

// API
export const getSpecLembur = createAsyncThunk(
    "claimPengobatanTransaksi/getSpecLembur",
    async ({TransaksiApprovalID}, thunkAPI) => {
        let formData = new FormData();
        formData.append("TransaksiApprovalID", TransaksiApprovalID);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'getSpecLembur',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const getLemburTransaksi = createAsyncThunk(
    "lemburTransaksi/get",
    async ({start, count, search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("start", start);
        formData.append("count", count);
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'getLembur',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const insertLemburTransaksi = createAsyncThunk(
    "lemburTransaksi/insert",
    async ({
               Nik,
               JenisLembur,
               KeperluanLembur,
               PemberiInstruksiLembur,
               TanggalMulai,
               TanggalAkhir,
               NoSPL
           }, thunkAPI) => {
        let formData = new FormData();
        formData.append("Nik", Nik);
        formData.append("JenisLembur", JenisLembur);
        formData.append("KeperluanLembur", KeperluanLembur);
        formData.append("PemberiInstruksiLembur", PemberiInstruksiLembur);
        formData.append("TanggalMulai", TanggalMulai);
        formData.append("TanggalAkhir", TanggalAkhir);
        formData.append("NoSPL", NoSPL);

        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'insertLembur',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const updateLemburTransaksi = createAsyncThunk(
    "lemburTransaksi/update",
    async ({
               TLemburID,
               Nik,
               JenisLembur,
               KeperluanLembur,
               PemberiInstruksiLembur,
               TanggalMulai,
               TanggalAkhir,
               NoSPL,
               JenisHariOverride
           }, thunkAPI) => {
        let formData = new FormData();
        formData.append("TLemburID", TLemburID);
        formData.append("Nik", Nik);
        formData.append("JenisLembur", JenisLembur);
        formData.append("KeperluanLembur", KeperluanLembur);
        formData.append("PemberiInstruksiLembur", PemberiInstruksiLembur);
        formData.append("TanggalMulai", TanggalMulai);
        formData.append("TanggalAkhir", TanggalAkhir);
        formData.append("NoSPL", NoSPL);
        // Kode 1/2/3 = override manual jenis hari (lihat kartu "Perhitungan Lembur"
        // di form); kosong = ikut auto-detect backend (kalender libur/hari Minggu).
        formData.append("JenisHariOverride", JenisHariOverride || "");


        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'updateLembur',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)
export const getLemburReport = createAsyncThunk(
    "getLemburReport/get",
    async (obj, thunkAPI) => {

        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'hrd/lembur/lap',
                obj,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)
export const getLemburReportDetail = createAsyncThunk(
    "getLemburReportDetail/get",
    async (obj, thunkAPI) => {

        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'hrd/lembur/lap/detail',
                obj,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)
export const resetLemburSlice = createAsyncThunk(
    "resetLemburSlice/update",
    async ({}, thunkAPI) => {
        return true
    }
)
export const resetLemburDetailSlice = createAsyncThunk(
    "resetLemburDetailSlice/update",
    async ({}, thunkAPI) => {
        return true
    }
)

export const deleteLembur = createAsyncThunk(
    "lemburTransaksi/delete",
    async ({ ID }, thunkAPI) => {
      let formData = new FormData();
      formData.append("ID", ID);
  
      try {
        const response = await axios.post(
          process.env.REACT_APP_API_URL + "deleteLembur",
          formData,
          {
            headers: {
              Authorization: "Bearer " + user.Token,
              Accept: "*/*",
            },
          }
        );
        if (response.status === 200) {
          return response.data;
        } else {
          return thunkAPI.rejectWithValue(response.data);
        }
      } catch (e) {
        thunkAPI.rejectWithValue(e.response.data);
      }
    }
  );
//INIT
const initialState = {
    message: "",
    SpecLemburData: [],
    isSpecLemburFetching: false,
    isSpecLemburSuccess: false,
    isSpecLemburError: false,
    isGetFetching: false,
    isGetSuccess: false,
    isGetError: false,
    isInsertFetching: false,
    isInsertSuccess: false,
    isInsertError: false,
    isUpdateFetching: false,
    isUpdateSuccess: false,
    isUpdateError: false,
    errorMessage: "",
    report: [],
    reportDetail: null,
    isGetReport: false,
    isGetReportDetail: false,
};


//SLICES
export const lemburTransaksiSlice = createSlice({
    name: "lemburTransaksi",
    initialState,
    reducers: {},
    extraReducers: {
        // GET
        [getLemburReport.fulfilled]: (state, {payload}) => {
            state.report = payload.data;
            state.isGetReport = true;
            state.message = payload.message;
            return state;
        },
        [getLemburReport.rejected]: (state, {payload}) => {
            state.isGetReport = false;
        },
        [getLemburReport.pending]: (state) => {
            state.isGetReport = false;
        },

        [getLemburReportDetail.fulfilled]: (state, {payload}) => {
            if (payload) {
                state.reportDetail = payload.data;
                state.message = payload.message;
            }
            state.isGetReportDetail = true;
            return state;
        },
        [getLemburReportDetail.rejected]: (state, {payload}) => {
            state.isGetReportDetail = false;
        },
        [getLemburReportDetail.pending]: (state) => {
            state.isGetReportDetail = false;
        },
        [resetLemburDetailSlice.pending]: (state) => {
            state.isGetReportDetail = false;
        },
        [getSpecLembur.fulfilled]: (state, {payload}) => {
            state.SpecLemburData = payload.data[0];
            state.isSpecLemburSuccess = true;
            state.message = payload.message;
            return state;
        },
        [getSpecLembur.rejected]: (state, {payload}) => {
            state.isSpecLemburFetching = false;
        },
        [getSpecLembur.pending]: (state) => {
            state.isSpecLemburFetching = false;
        },

        [getLemburTransaksi.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.data = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getLemburTransaksi.rejected]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetError = true;
            state.errorMessage = payload.message;
        },
        [getLemburTransaksi.pending]: (state) => {
            state.isGetFetching = true;
        },

        // INSERT
        [insertLemburTransaksi.fulfilled]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [insertLemburTransaksi.rejected]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertError = true;
            state.errorMessage = payload.message;
        },
        [insertLemburTransaksi.pending]: (state) => {
            state.isInsertFetching = true;
        },

        // UPDATE
        [updateLemburTransaksi.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [updateLemburTransaksi.rejected]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
            state.errorMessage = payload.message;
        },
        [updateLemburTransaksi.pending]: (state) => {
            state.isUpdateFetching = true;
        },

        [deleteLembur.fulfilled]: (state, { payload }) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [deleteLembur.rejected]: (state, { payload }) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
            state.errorMessage = payload.message;
        },
        [deleteLembur.pending]: (state) => {
            state.isUpdateFetching = true;
        },
    },
});


export const lemburTransaksiSelector = (state) => state.lemburTransaksi;
